if (!customElements.get('gift-drawer')) {
  class GiftDrawer extends HTMLElement {
    constructor() {
      super();
    }

    addEventListeners() {
      document.addEventListener('initGiftDrawer', this.initGiftDrawer.bind(this));
      document.addEventListener('triggerSuccessMessage', this.triggerSuccessMessage.bind(this));
      document.addEventListener('removeSuccessMessage', this.removeSuccessMessage.bind(this));
      document.addEventListener('alexa:open-gift-drawer', (event) => {
        event.preventDefault();
        this.initGiftDrawer();
      });
      document.addEventListener('closeGiftDrawer', this.closeGiftDrawer.bind(this));
      this.$closeBtn.addEventListener('click', this.closeGiftDrawer.bind(this));
    };

    triggerSuccessMessage() {
      if (!this.$successMessage.hasClass('is-active')) {
        this.$successMessage.addClass('is-active');
      }
    };

    removeSuccessMessage() {
      this.$successMessage.classList.remove('is-active');
    };

    initGiftDrawer() {
      this.showGiftDrawer();
    };

    showGiftDrawer() {
      this.$giftDrawer.classList.add('is-active');
    };

    closeGiftDrawer(event) {
      event.preventDefault();
      this.$giftDrawer.classList.remove('is-active');
    };

    connectedCallback() {
      this.$giftDrawer = document.querySelector('.js-gift-drawer');
      this.$closeBtn = this.$giftDrawer.querySelector('.js-gift-drawer-close');
      this.$successMessage = this.querySelector('.js-drawer-success');
      this.$cartPageDrawerClose = document.querySelector(
        '.js-gift-drawer-close-cart-page'
      );

      if (this.$cartPageDrawerClose) {
        this.$cartPageDrawerClose.addEventListener(
          'click',
          this.closeGiftDrawer.bind(this)
        );
      }

      this.addEventListeners();
    }
  }

  customElements.define('gift-drawer', GiftDrawer);
}
